import type { AnchorHTMLAttributes } from "react";
import { publicStoryPath } from "../lib/routes";
import type { PublicStory } from "../types";

export type OpenStory = (story: PublicStory, chapter?: string) => void;
export function StoryLink({ story, chapter, onOpen, ...props }: AnchorHTMLAttributes<HTMLAnchorElement> & { story: PublicStory; chapter?: string; onOpen: OpenStory }) {
  return <a {...props} href={publicStoryPath(story.slug) + (chapter ? "#" + encodeURIComponent(chapter) : "")} onClick={event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onOpen(story, chapter);
  }} />;
}
